import { NetworkContextName } from "../constants";
import { Web3Provider } from "@ethersproject/providers";
import { Web3ReactContextInterface } from "@web3-react/core/dist/types";
import { useWeb3React as useWeb3ReactCore } from "@web3-react/core";
import { SupportedChainId } from "../constants/chains";
import { useGetMainNetwork } from "../state/application/hooks";

export function useActiveWeb3React(): Web3ReactContextInterface<Web3Provider> & {
  chainId?: SupportedChainId;
} {
  // replace with address to impersonate
  const impersonate = false;
  const context = useWeb3ReactCore<Web3Provider>();
  const contextNetwork = useWeb3ReactCore<Web3Provider>(NetworkContextName);
  const contextNet = context.active ? context : contextNetwork;
  return contextNet;
}

export default useActiveWeb3React;
